/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-nested-ternary */
import React, { Suspense, useMemo } from "react";
import ReactGA from "react-ga4";
import { Provider } from "react-redux";
import { ThemeProvider, StyledEngineProvider, CssBaseline } from "@mui/material";

import { Router, Switch } from "react-router-dom";
import { IntlProvider } from "react-redux-multilingual";
import { createHashHistory } from "history";
import "./styles/App.scss";
import "./styles/App.less";
import "./index.scss";
import store from "./store";
import * as translations from "./constants/translations.json";
import ErrorBoundary from "./routes/ErrorBoundary";
import { MarketplaceAppRoutes, SellerMgmtRoutes, AdminMgmtRoutes, ShopWebsiteRoutes, LocalMarketWebsiteRoutes } from "./routes";
import AuthenticatedRoute from "./routes/AuthenticatedRoute";
import { ShopWebSiteExcludedRoutes, MarketplaceExcludedRoutes, LocalMarketExcludedRoutes, AdminMgmtExcludededRoutes, SellerMgmtExcludedRoutes } from "./config/ExcludedRoutes";

import Bootstrap from "./components/hoc/Bootstrap";
import theme from "./theme/theme";
import LoadingFallback from "./components/common/LoadingFallback";
import { getPlatform } from "./helpers/utils";

const history = createHashHistory();

if (process.env.REACT_APP_ENV === "production") {

  const options = {
    //gaOptions: {
    //  ...(process.env.REACT_APP_ENV === "production" && { cookie_domain: process.env.REACT_APP_GOOGLE_ANALYTICS_DOMAIN }),
    //  cookieFlags: "SameSite=None;Secure"
    //},
  };

  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID, options);

  ReactGA.set({ app_platform: getPlatform() });
}

const App = () => {
  // Memoize the route configuration to prevent unnecessary re-renders
  const routeConfig = useMemo(() => {
    const appType = process.env.REACT_APP_TYPE;
    
    const routeMap = {
      SELLERAPP: { routes: SellerMgmtRoutes, excluded: SellerMgmtExcludedRoutes },
      ADMINAPP: { routes: AdminMgmtRoutes, excluded: AdminMgmtExcludededRoutes },
      USERSITE: { routes: ShopWebsiteRoutes, excluded: ShopWebSiteExcludedRoutes },
      MARKETPLACE: { routes: MarketplaceAppRoutes, excluded: MarketplaceExcludedRoutes },
      LOCALMARKET: { routes: LocalMarketWebsiteRoutes, excluded: LocalMarketExcludedRoutes },
    };
    
    return routeMap[appType] || { routes: MarketplaceAppRoutes, excluded: MarketplaceExcludedRoutes };
  }, []);

  // Determine appropriate loading fallback based on app type
  const getLoadingFallback = useMemo(() => {
    const appType = process.env.REACT_APP_TYPE;
    
    switch (appType) {
      case 'MARKETPLACE':
      case 'LOCALMARKET':
        return <LoadingFallback type="page" />;
      case 'USERSITE':
        return <LoadingFallback type="products" />;
      case 'SELLERAPP':
      case 'ADMINAPP':
        return <LoadingFallback message="Loading dashboard..." />;
      default:
        return <LoadingFallback />;
    }
  }, []);

  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <IntlProvider translations={translations} locale="en">
            <Router basename="/#" history={history}>
              <ErrorBoundary>
                <Bootstrap>
                  <Suspense fallback={getLoadingFallback}>
                    <Switch>
                      {routeConfig.routes.map((item, index) => (
                        <AuthenticatedRoute
                          excluded={routeConfig.excluded}
                          key={`${item.path}-${index}`}
                          path={item.path}
                          exact={item.exact}
                          component={item.component}
                          store={store}
                        />
                      ))}
                    </Switch>
                  </Suspense>
                </Bootstrap>
              </ErrorBoundary>
            </Router>
          </IntlProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
};

export default App;
